import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { AccountCircle, ExpandLess, ExpandMore } from '@mui/icons-material';
import classNames from 'classnames';
import ResidencyType from '../../enums/ResidencyType'
import { fetchPersonalDataIfNeeded } from '../../actions/personalDetails'
import { getConfiguration } from '../../helpers/configuration'
import { getProperty } from '../../helpers/properties'
import { getLogoutRequest } from '../../services/vu';

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, personalDetails }) => {
  return {
    courseId: selectedCourseCode,
    personalDetails: personalDetails.data,
    isOffshoreFlag: selectedCourse.isOffshoreFlag
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPersonalDetails: () => {
      dispatch(fetchPersonalDataIfNeeded())
    }
  }
}

class UserDropdown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      userMenuOpen: false,
      selectedMenuItem: ''
    }
  }

  componentDidMount() {
    this.props.fetchPersonalDetails()
  }

  isUSIApplicable = () => {
    if (
      this.props.personalDetails &&
      (ResidencyType.Domestic.includes(this.props.personalDetails.stuCitizenCd) ||
        (ResidencyType.International.includes(this.props.personalDetails.stuCitizenCd) && !this.props.isOffshoreFlag))
    ) {
      return true
    } else {
      return false
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({
        userMenuOpen: false
      })
    }
  }

  toggleUserMenu = () => {
    this.setState({
      userMenuOpen: !this.state.userMenuOpen
    })
  }

  handleOnBlur = event => {
    if (!event.relatedTarget || (!event.relatedTarget.classList.contains('user-menu__item') && !event.relatedTarget.classList.contains('header-button--user'))) {
      this.setState({
        userMenuOpen: false
      })
    }
  }

  handleLogout = event => {
    //event.preventDefault();
    this.handleOnBlur(event)
    //window.location.assign('/api/logout/myvu')
  }

  handleLogoutOnBlur = event => {
    this.handleOnBlur(event)
    localStorage.clear()
    sessionStorage.clear()
  }

  render() {
    return (
      <div className={classNames('user-info__dropdown', { 'user-info__dropdown--open': this.state.userMenuOpen })}>
        <button
          aria-haspopup={true}
          aria-expanded={this.state.userMenuOpen ? 'true' : 'false'}
          className="header-button header-button--user"
          onClick={this.toggleUserMenu}
          onBlur={this.handleOnBlur}
        >
          <AccountCircle className="btn-point-events" />
          <span className="sr-only btn-point-events">Toggle User Menu</span>
          {this.props.preferredName && <span className="btn-point-events hello-msg">Hi {this.props.preferredName}</span>}
          {this.state.userMenuOpen ? <ExpandLess className="btn-point-events" /> : <ExpandMore className="btn-point-events" />}
        </button>
        <div className="user-menu" role="menu">
          <Link className="user-menu__item user--settings" to={getConfiguration('baseUrl') + '/settings'} onBlur={this.handleOnBlur} role="menuitem">
            My personal details
          </Link>
          {this.isUSIApplicable() && (
            <Link className="user-menu__item user--settings" to={getConfiguration('baseUrl') + '/usidetails'} onBlur={this.handleOnBlur} role="menuitem">
              USI details
            </Link>
          )}
          <a className="user-menu__item user--change-password" target="blank" href={getProperty('changePasswordUrl')} onBlur={this.handleOnBlur} role="menuitem">
            Change password
          </a>
          <a className="user-menu__item user--log-out" href={'/api/logout/myvu'} onClick={this.handleLogout} onBlur={this.handleLogoutOnBlur} role="menuitem">
            Sign out
          </a>
        </div>
      </div>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserDropdown)
)
